import React, { useState } from "react";
import axios from "axios";
import { Gift } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [signedUp, setSignedUp] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    const list = JSON.parse(localStorage.getItem("mm_newsletter") || "[]");
    list.push({ email, at: Date.now() });
    localStorage.setItem("mm_newsletter", JSON.stringify(list));
    try {
      await axios.post(`${API}/leads`, { email: email.trim(), source: "newsletter_section" });
    } catch (err) {
      console.warn("Lead capture failed", err?.response?.status || err?.message);
    }
    setSignedUp(true);
    toast({ title: "Welcome to the family", description: "Your $5 code is on the page — use WELCOME10 at checkout." });
    setEmail("");
  };

  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[900px] mx-auto px-6 md:px-12 text-center fade-in">
        <div className="section-label mb-4 flex items-center justify-center gap-2">
          <Gift size={13} className="text-[var(--mm-accent)]" />
          <span>Join the family · get $5 off</span>
        </div>
        <h2 className="font-display text-5xl md:text-7xl italic font-light text-[var(--mm-cream)] leading-[0.95] mb-6">
          Feed your <span className="text-[var(--mm-accent)]">inbox.</span>
        </h2>
        <p className="text-[var(--mm-cream-muted)] max-w-lg mx-auto font-light mb-10">
          Drop your email and we&apos;ll send you a <strong className="text-[var(--mm-accent)]">$5 off welcome code</strong> plus Sunday feast menus, new dishes, and the occasional recipe from mama&apos;s own hand.
        </p>

        {signedUp ? (
          <div
            className="max-w-md mx-auto border border-[var(--mm-accent)] bg-[var(--mm-accent)]/10 px-6 py-6 fade-in visible"
            data-testid="newsletter-success"
          >
            <p className="section-label mb-2 text-[var(--mm-accent)]">Your welcome gift</p>
            <p className="font-display text-3xl italic text-[var(--mm-cream)] mb-2">
              WELCOME10
            </p>
            <p className="text-xs text-[var(--mm-cream)]/60 tracking-wide">
              Copy this at checkout for 10% off your first order.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="newsletter-email-input"
              className="flex-1 bg-transparent border border-[var(--mm-line)] text-[var(--mm-cream)] placeholder:text-[var(--mm-cream-muted)]/60 px-5 py-4 focus:border-[var(--mm-accent)] outline-none"
            />
            <button type="submit" className="btn-primary" data-testid="newsletter-submit">
              Send my $5 code
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
